import { NgIf } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, HostBinding } from '@angular/core';
import { NgDocCopyButtonComponent } from '@ng-doc/app/components/copy-button';
import { NgDocSanitizeHtmlPipe } from '@ng-doc/app/pipes';
import { NgDocPageProcessorComponent } from '@ng-doc/app/processors/page-processor';
import { linkProcessor } from '@ng-doc/app/processors/processors/link';
import { tooltipProcessor } from '@ng-doc/app/processors/processors/tooltip';
import { provideMainPageProcessor } from '@ng-doc/app/tokens';
import { NgDocTextComponent, NgDocIconComponent, NgDocButtonIconComponent, NgDocTooltipDirective, NgDocSmoothResizeComponent } from '@ng-doc/ui-kit';
const _c0 = ["*"];
function NgDocCodeComponent_div_0_ng_doc_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ng-doc-icon", 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("customIcon", ctx_r0.icon);
  }
}
function NgDocCodeComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "span", 6);
    i0.ɵɵtemplate(2, NgDocCodeComponent_div_0_ng_doc_icon_2_Template, 1, 1, "ng-doc-icon", 7);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.icon);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.name, " ");
  }
}
function NgDocCodeComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 2);
    i0.ɵɵpipe(1, "ngDocSanitizeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngDocPageProcessor", i0.ɵɵpipeBind1(1, 1, ctx_r0.html));
  }
}
function NgDocCodeComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
}
function NgDocCodeComponent_ng_doc_copy_button_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ng-doc-copy-button", 9);
    i0.ɵɵelement(1, "ng-doc-icon", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_1_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("text", (tmp_1_0 = ctx_r0.codeElement == null ? null : ctx_r0.codeElement.textContent) !== null && tmp_1_0 !== undefined ? tmp_1_0 : "");
  }
}
let NgDocCodeComponent = /*#__PURE__*/(() => {
  class NgDocCodeComponent {
    constructor(elementRef) {
      this.elementRef = elementRef;
      this.html = '';
      this.copyButton = true;
    }
    get hasHeader() {
      return !!this.name || !!this.icon;
    }
    get codeElement() {
      return this.elementRef?.nativeElement.querySelector('code') ?? null;
    }
    static {
      this.ɵfac = function NgDocCodeComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocCodeComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgDocCodeComponent,
        selectors: [["ng-doc-code"]],
        hostVars: 1,
        hostBindings: function NgDocCodeComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("data-ng-doc-has-header", ctx.hasHeader);
          }
        },
        inputs: {
          html: "html",
          copyButton: "copyButton",
          name: "name",
          icon: "icon"
        },
        standalone: true,
        features: [i0.ɵɵProvidersFeature([], [provideMainPageProcessor([linkProcessor, tooltipProcessor])]), i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 5,
        vars: 3,
        consts: [["class", "ng-doc-code-header", 4, "ngIf"], [1, "ng-doc-code-body"], [1, "ng-doc-code-wrapper", 3, "ngDocPageProcessor"], [1, "ng-doc-code-wrapper"], ["class", "ng-doc-copy-button", 3, "text", 4, "ngIf"], [1, "ng-doc-code-header"], ["ng-doc-text", "", 1, "ng-doc-code-file-name"], [3, "customIcon", 4, "ngIf"], [3, "customIcon"], [1, "ng-doc-copy-button", 3, "text"], ["icon", "copy"]],
        template: function NgDocCodeComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, NgDocCodeComponent_div_0_Template, 4, 2, "div", 0);
            i0.ɵɵelementStart(1, "div", 1);
            i0.ɵɵtemplate(2, NgDocCodeComponent_Conditional_2_Template, 2, 3, "div", 2)(3, NgDocCodeComponent_Conditional_3_Template, 2, 0, "div", 3)(4, NgDocCodeComponent_ng_doc_copy_button_4_Template, 2, 1, "ng-doc-copy-button", 4);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.hasHeader);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.html ? 2 : 3);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.copyButton);
          }
        },
        dependencies: [NgIf, NgDocTextComponent, NgDocIconComponent, NgDocPageProcessorComponent, NgDocCopyButtonComponent, NgDocSanitizeHtmlPipe],
        styles: ["[_nghost-%COMP%]{position:relative;display:block;margin:var(--ng-doc-code-margin)}[_nghost-%COMP%]:hover   .ng-doc-copy-button[_ngcontent-%COMP%]{opacity:1}[data-ng-doc-has-header=true][_nghost-%COMP%]{--ng-doc-code-border-radius: 0 0 var(--ng-doc-base-gutter) var(--ng-doc-base-gutter);--ng-doc-code-shadow: none}[_nghost-%COMP%]   .ng-doc-code-wrapper[_ngcontent-%COMP%]{--ng-doc-code-margin: 0;--ng-doc-code-border: none}[_nghost-%COMP%]   .ng-doc-code-header[_ngcontent-%COMP%]{display:flex;align-items:center;padding:var(--ng-doc-base-gutter) calc(var(--ng-doc-base-gutter) * 2);background:var(--ng-doc-code-header-background, var(--ng-doc-base-2));border-radius:var(--ng-doc-base-gutter) var(--ng-doc-base-gutter) 0 0;border-top:var(--ng-doc-code-border, 1px solid var(--ng-doc-border-color));border-left:var(--ng-doc-code-border, 1px solid var(--ng-doc-border-color));border-right:var(--ng-doc-code-border, 1px solid var(--ng-doc-border-color))}[_nghost-%COMP%]   .ng-doc-code-header[_ngcontent-%COMP%]   .ng-doc-code-file-name[_ngcontent-%COMP%]{--ng-doc-text: var(--ng-doc-code-header-color);--ng-doc-font-weight: 600;--ng-doc-font-size: 13px}[_nghost-%COMP%]   .ng-doc-code-header[_ngcontent-%COMP%]   .ng-doc-code-file-name[_ngcontent-%COMP%]   ng-doc-icon[_ngcontent-%COMP%]{margin-right:calc(var(--ng-doc-base-gutter) / 2)}[_nghost-%COMP%]   .ng-doc-copy-button[_ngcontent-%COMP%]{position:absolute;top:var(--ng-doc-base-gutter);right:var(--ng-doc-base-gutter);transition:var(--ng-doc-transition);opacity:0;--ng-doc-icon-color: var(--ng-doc-text-muted)}[_nghost-%COMP%]   .ng-doc-code-wrapper[_ngcontent-%COMP%]{height:100%}[_nghost-%COMP%]   .ng-doc-code-body[_ngcontent-%COMP%]{position:relative;height:100%;border-radius:var(--ng-doc-code-border-radius, var(--ng-doc-base-gutter));border:var(--ng-doc-code-border, 1px solid var(--ng-doc-border-color));overflow:hidden}[_nghost-%COMP%]   .ng-doc-code-body[_ngcontent-%COMP%]     pre{display:flex;margin:var(--ng-doc-code-margin);height:100%}[_nghost-%COMP%]   .ng-doc-code-body[_ngcontent-%COMP%]     pre code{display:block;padding:calc(var(--ng-doc-base-gutter) * 2) 0;width:100%;font-family:var(--ng-doc-code-font);font-size:var(--ng-doc-code-font-size);line-height:var(--ng-doc-code-line-height);max-height:var(--ng-doc-code-max-height);overflow:auto;height:100%}[_nghost-%COMP%]   .ng-doc-code-body[_ngcontent-%COMP%]     pre code.code-lines{display:grid;padding:calc(var(--ng-doc-base-gutter) * 2) 0}[_nghost-%COMP%]   .ng-doc-code-body[_ngcontent-%COMP%]     pre code .line{display:inline-block;width:100%;padding:0 calc(var(--ng-doc-base-gutter) * 2)}[_nghost-%COMP%]   .ng-doc-code-body[_ngcontent-%COMP%]     pre code .line.highlighted{position:relative;background:color-mix(in srgb,var(--ng-doc-code-highlight-color),transparent 90%)!important}[_nghost-%COMP%]   .ng-doc-code-body[_ngcontent-%COMP%]     pre code .line.highlighted span{background:transparent!important}[_nghost-%COMP%]   .ng-doc-code-body[_ngcontent-%COMP%]     pre code .line.highlighted:after{content:\"\";position:absolute;top:0;left:0;width:3px;height:100%;background:var(--ng-doc-code-highlight-color);opacity:.8}"],
        changeDetection: 0
      });
    }
  }
  return NgDocCodeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgDocCodeComponent };
